/* global window, document, location */

'use strict';

/* globals $, config, define */


define('file-functions', ['uploader'], function (uploader) {
	var fileFunctions = {};
	fileFunctions.setupUploader = function () {
		$('#content input[data-action="upload"]').each(function () {
			var uploadBtn = $(this);
			uploadBtn.on('click', function () {
				uploader.show({
					route: config.relative_path + '/hash-file-manager/upload/',
					params: {
						folder: 'hash-file-manager',
					},
					accept: '*/*',
				}, function () {
					location.reload();
				});
			});
		});
	};

	fileFunctions.setupCopyFile = function () {
		$('#content button[data-action="copy"]').each(function () {
			var copyBtn = $(this);
			copyBtn.on('click', function () {
				var endpoint = window.location.origin + '/hash-file-manager/download/' + copyBtn.attr('file-id');
				var dummy = document.createElement('textarea');
				document.body.appendChild(dummy);
				dummy.value = endpoint;
				dummy.select();
				document.execCommand('copy');
				document.body.removeChild(dummy);
			});
		});
	};

	fileFunctions.setupCopyFileForPost = function () {
		$('#content button[data-action="copy-for-post"]').each(function () {
			var copyBtn = $(this);
			copyBtn.on('click', function () {
				var filename = copyBtn.attr('filename');
				var dotIndex = filename.lastIndexOf('.');
				if (dotIndex !== -1) {
					filename = filename.substr(0, dotIndex);
				}
				var content = '[' + filename + '](' + window.location.origin + '/hash-file-manager/download/' + copyBtn.attr('file-id') + ')';
				var dummy = document.createElement('textarea');
				document.body.appendChild(dummy);
				dummy.value = content;
				dummy.select();
				document.execCommand('copy');
				document.body.removeChild(dummy);
			});
		});
	};

	fileFunctions.setupDeleteFile = function () {
		$('#content button[data-action="delete"]').each(function () {
			var deleteBtn = $(this);
			deleteBtn.on('click', function () {
				$.post(config.relative_path + '/hash-file-manager/delete', { fileID: deleteBtn.attr('file-id') }, function () {
					location.reload();
				});
			});
		});
	};

	return fileFunctions;
});
